// Điểm mở rộng của module Doanh số & KPI (FSD.md §2.1, §3.9): không có Tạo mới / Tìm nhanh / lớp phủ; thời gian thực.
import { qk, type RealtimeBinding } from '@/shared/api';
import type { CreateItem } from '@/widgets/app-shell';

/** Không có mục "Tạo mới" (chỉ tiêu đặt ngay trên trang Doanh số; số liệu sinh từ khách và giao dịch). */
export const createItems: CreateItem[] = [];

/**
 * - `sales` (performance-service sau khi lưu chỉ tiêu tháng, { month }) ⇒ báo cáo + bảng chỉ tiêu đang mở + Tổng quan.
 * - `deals` / `crm.customers` (giao dịch, khách đổi) ⇒ doanh số là projection bất đồng bộ của performance ⇒ gộp 1,5 s rồi
 *   mới tải lại (invalidateSoon của FSD §3.9).
 */
export const realtime: RealtimeBinding[] = [
  { topic: 'sales', module: 'sales', keys: () => [qk.sales.all, qk.dashboard.all] },
  { topic: 'deals', module: 'sales', keys: () => [qk.sales.all], throttleMs: 1500 },
  { topic: 'crm.customers', module: 'sales', keys: () => [qk.sales.all], throttleMs: 1500 },
];
